/** Walk analysis report tab */
import {
  AnkleMobilityStatusModalContent,
  HipMobilityStatusModalContent,
  KneeMobilityStatusModalContent,
  PelvisMobilityStatusModalContent,
} from '@/pages/ReportV2/components/Modals';
import { IonCol, IonRow, IonText } from '@ionic/react';
import { useState } from 'react';

import { CardHeader } from '@/components/CardHeader/cardHeader';
import { MobilityStatusCard, Card } from '@/components/Cards';

import Ankle from '@/assets/avatars/walk/analysis/Ankle.png';
import Hip from '@/assets/avatars/walk/analysis/Hip.png';
import Knee from '@/assets/avatars/walk/analysis/Knee.png';
import Pelvis from '@/assets/avatars/walk/analysis/Pelvis.png';

import { MobilityStatusData } from '@/models/reportV2.model';

import styles from '@/pages/ReportV2/Styles/Reports.module.css';

type WalkReportProps = {
  tabData: MobilityStatusData;
};

/** The Walk analysis report tab
 * @param report - The full walk report info and data
 */
export const WalkMobilityReportTab = ({ tabData }: WalkReportProps) => {
  const [showModal, setShowModal] = useState({
    show: false,
  });

  if (!tabData) {
    return <IonText>Data not found.</IonText>;
  }
  return (
    <>
      <IonRow style={{ height: '100%', padding: 0, alignContent: 'space-evenly' }}>
        <Card style={{ height: 'fit-content', marginLeft: 0, marginRight: 0 }}>
          <CardHeader
            title={
              <>
                Stride Duration: {tabData.tableData[0][0].toFixed(2)}s.
                <span
                  className={
                    tabData.tableData[0][4] === 1
                      ? styles.qualityLabel_succes
                      : tabData.tableData[0][4] === 2
                        ? styles.qualityLabel_danger
                        : styles.qualityLabel_warning
                  }
                  id='showSpeedLabel'
                  style={{ marginLeft: '10px' }}>
                  {' '}
                  {tabData.speedLabel}{' '}
                </span>
              </>
            }
          />
        </Card>

        <IonCol size='3'>
          <MobilityStatusCard
            img={Pelvis}
            info={<PelvisMobilityStatusModalContent />}
            romRow={tabData.romData[0]}
            statusRow={tabData.statusData[0]}
            title={'Pelvis'}
          />
        </IonCol>
        <IonCol size='3'>
          <MobilityStatusCard
            img={Hip}
            info={<HipMobilityStatusModalContent />}
            romRow={tabData.romData[1]}
            statusRow={tabData.statusData[1]}
            title={'Hip'}
          />
        </IonCol>
        <IonCol size='3'>
          <MobilityStatusCard
            img={Knee}
            info={<KneeMobilityStatusModalContent />}
            romRow={tabData.romData[4]}
            statusRow={tabData.statusData[2]}
            title={'Knee'}
          />
        </IonCol>
        <IonCol size='3'>
          <MobilityStatusCard
            img={Ankle}
            info={<AnkleMobilityStatusModalContent />}
            romRow={tabData.romData[7]}
            statusRow={tabData.statusData[3]}
            title={'Ankle'}
          />
        </IonCol>
      </IonRow>
    </>
  );
};
